import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useIsTruncated } from 'hooks/useIsTruncated';

const BreadcrumbTooltipItem = ({ title, isMiddleActive }: { title: string; isMiddleActive: boolean }) => {
  const { ref, isTruncated } = useIsTruncated([title]);

  return (
    <Tooltip title={isTruncated ? title : ''} enterDelay={700} disableHoverListener={!isTruncated}>
      <Typography sx={{ color: 'rgba(0, 40, 58, 0.87)', maxWidth: isMiddleActive ? '89px' : '154px' }} ref={ref} variant="body2" noWrap>
        {title}
      </Typography>
    </Tooltip>
  );
};

export default BreadcrumbTooltipItem;
